/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  SET_BEARER (state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
	setToken(state, data) {  
		state.ROLE = data.ROLE;
		state.servisAdresi = data.servisAdresi;
		state.fullFilmentTokenId = data.fullFilmentTokenId;
		state.userCode = data.userCode;
		state.userName = data.userName;
		state.expiration = data.expiration;
		state.userId = data.userId;
		state.companyId = data.companyId;
	},

}
